export enum ProxyServerRequest {
    MyWayServerRequest = 'MyWayServerRequest',
    IturanServerRequest = 'IturanServerRequest',
    GpsServerRequest = 'GpsServerRequest',
    TransitServerRequest = 'TransitServerRequest',
}

const proxyServerRequestValues = Object.values(ProxyServerRequest);

export const isProxyServerRequest = (rawUrl = ''): boolean => {
    const lower = rawUrl.toLowerCase();
    return proxyServerRequestValues.some((name) => lower.endsWith(name.toLowerCase()));
};

export const isMyWayStudioServiceReq = (rawUrl = '', baseURL = '') => {
    if (!rawUrl || typeof rawUrl !== 'string') return false;

    const lower = rawUrl.toLowerCase();

    if (lower.startsWith('/')) {
        return lower.includes('/mywaystudioservices/');
    }

    try {
        const u = new URL(rawUrl, baseURL);
        return u.pathname.toLowerCase().includes('/mywaystudioservices/');
    } catch {
        return lower.includes('mywaystudioservices');
    }
};